import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vine': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-0.8-27.1-16.3-129.9-100.6-164.1-365.6h74.5c18.7 159.1 64.5 240.7 114.8 301.8 27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 0.1 79.2 59.4 118.7 129.9 101.9z'
      }
    ]
  }
})
